import { render, staticRenderFns } from "./DuelsGameStats.vue?vue&type=template&id=8f0698f6&scoped=true"
import script from "./DuelsGameStats.vue?vue&type=script&lang=js"
export * from "./DuelsGameStats.vue?vue&type=script&lang=js"
import style0 from "./DuelsGameStats.vue?vue&type=style&index=0&id=8f0698f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0698f6",
  null
  
)

export default component.exports